import {Component, Optional, ViewChild} from '@angular/core';
import {CsvPropertiesConfirmResponse, CsvPropertiesMapRequest, FileUploadComponent} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';
import {ConfirmationService, MessageService} from 'primeng/api';
import {PeopleImportService} from '../../../_services/people-import.service';

const enum CsvProcessingState {
    pending = 0, // Pending file upload
    waiting = 1, // Waiting for user to confirm
    processing = 2 // Processing the confirmation by the API
}

@Component({
    selector: 'acabim-admin-import-users',
    templateUrl: './import-users.component.html',
    styleUrls: ['./import-users.component.scss'],
    providers: [MessageService]
})
export class ImportUsersComponent {

    @ViewChild('csvUploader', {static: false}) public csvUploader?: FileUploadComponent;

    public csvProcessingState = CsvProcessingState.pending;

    public set csvMapRequest(req: CsvPropertiesMapRequest | undefined) {
        this._csvMapRequest = req;
        if (req) {
            this.csvProcessingState = CsvProcessingState.waiting;
        }
    }

    public get csvMapRequest(): CsvPropertiesMapRequest | undefined {
        return this._csvMapRequest;
    }

    private _csvMapRequest?: CsvPropertiesMapRequest;

    constructor(private readonly peopleImportService: PeopleImportService,
                private readonly confirmationService: ConfirmationService,
                public readonly messageService: MessageService,
                @Optional() private readonly logger?: NGXLogger) { }

    public startImportSession(): void {
        if (this.csvUploader && this.csvUploader.file) {
            this.csvUploader.startUpload(this.peopleImportService.startSession(this.csvUploader.file, (result => {
                this.csvMapRequest = result;
            })));
        }
    }

    public confirmCsvMapRequest(result: CsvPropertiesConfirmResponse): void {
        this.confirmationService.confirm({
           message: 'This will send invitation emails to all users found in the CSV. Continue?',
           accept: () => {
               this.csvProcessingState = CsvProcessingState.pending;
               this.peopleImportService.confirmImport(result).subscribe(_ => {
                   this.messageService.add({severity: 'success', summary: 'User invitation request successful'});
                   this.csvMapRequest = undefined;
                   this.csvProcessingState = CsvProcessingState.pending;
               }, error => {
                   this.logger?.error('[ImportUsersComponent] Import Failed', error);
                   this.messageService.add({severity: 'error', summary: 'User invitations failed'});
                   this.csvProcessingState = CsvProcessingState.waiting;
               });
           }
        });
    }
}
